import { createFileRoute, notFound } from "@tanstack/react-router";
import { z } from "zod";

const DEBUG_DESCRIPTION =
  "Internal diagnostics surface for Glider webapp-v2 development and support workflows.";
const DEBUG_TITLE = "Debug | Glider";

export const Route = createFileRoute("/_app/debug")({
  validateSearch: z.object({
    preview: z.literal("portfolio-investment").optional().catch(undefined),
  }),
  beforeLoad: () => {
    // The explicit staging-only build gate keeps /debug reachable for the
    // Walletless SIWE E2E lane; production builds never set it.
    if (
      !(
        import.meta.env.DEV ||
        import.meta.env.MODE === "test" ||
        import.meta.env.VITE_ENABLE_WALLETLESS_SIWE_E2E === "1"
      )
    ) {
      throw notFound();
    }
  },
  head: () => ({
    meta: [
      { title: DEBUG_TITLE },
      { content: DEBUG_DESCRIPTION, name: "description" },
      { content: DEBUG_TITLE, property: "og:title" },
      { content: DEBUG_DESCRIPTION, property: "og:description" },
      { content: "noindex, nofollow", name: "robots" },
      { content: "summary", name: "twitter:card" },
      { content: DEBUG_TITLE, name: "twitter:title" },
      { content: DEBUG_DESCRIPTION, name: "twitter:description" },
    ],
  }),
});
